export const GLOBAL_TERRITORY = {
    ID: 0,
    NAME: 'Global'
};
export const ALL_SERVICE = {
    ID: 0,
    NAME: 'All'
};
export const CM_UI_SUPPORT_SERVICE_ID_LIST = [1, 2, 3]; // AMU / PRIME / AMF
